import { decode } from 'js-base64';
import { NotificationCard } from '../../components/Card';
import { Icon, Button, Flex, Text, Center } from '@chakra-ui/react';
import { useMarkAsReadMutation } from '@/store/query/notification';
import { NotificationLink } from '../../components/NotificationLink';
import { MessageCircle01 } from '@kula-ai/icons/outline/MessageCircle01';
import { NotificationTime } from '../../components/Time';

const NoteMention = ({ notification = {}, onClose = () => {} }) => {
  const [markAsRead] = useMarkAsReadMutation();
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));

  const {
    note_url,
    sender_name,
    contact_name,
    contact_id = '137083', // Todo remove this once BE adds support
    note_content,
  } = data;

  return (
    <Flex alignItems="baseline" gap="6px">
      <Center minW="46px" h="46px" borderRadius="full" bg="ats-tertiary">
        <Icon as={MessageCircle01} color="ats-primary" />
      </Center>
      <Flex flexDir="column" ml="16px" gap="6px" alignSelf="start">
        <Text size="sm-semi-bold">You’ve been mentioned in a note!</Text>
        <Text>
          <Text as="span" size="sm-semi-bold">
            {sender_name}
          </Text>
          <Text as="span" fontSize="sm">
            {' '}
            has mentioned you in a note about{' '}
          </Text>
          <Text as="span" size="sm-semi-bold">
            <NotificationLink
              to={`/candidates/${contact_id}`}
              label={contact_name}
              onClose={onClose}
              notification={notification}
            />
          </Text>
        </Text>
        <Flex
          border="1px solid"
          borderColor="border-color"
          borderRadius="sm"
          p="14px"
        >
          <Text fontSize="sm">{note_content}</Text>
        </Flex>
        <NotificationTime notification={notification} />
        <Button
          w="fit-content"
          variant="ats-primary"
          borderRadius="8px"
          onClick={() => {
            markAsRead();
            window.open(note_url, '_self');
            onClose();
          }}
          maxH="34px"
          data-test-id="reply-note-button"
        >
          Reply now
        </Button>
      </Flex>
    </Flex>
  );
};

export const NoteMentionNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <NoteMention notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
